export default __webpack_public_path__ + "static/media/no-image-planar.58113df4.png";